import { toast } from "react-toastify";
import api from "../../api/api";
import { QUERY_ADMIN_REPORT_SUMMARY } from "../../api/queryKeys";

/*
SERVICE
This is the service for reporting. Since these are not as much shareable hooks and more one-time calls, we can just use a class here.
*/
class ReportingService {
  async generateResultsSummaryReport({
    doDownload = true,
  }: {
    doDownload?: boolean;
  }) {
    try {
      toast.info("Report is being generated. Please wait...");
      const response = await api.get(QUERY_ADMIN_REPORT_SUMMARY);
      if (response.data) {
        toast.dismiss();
        toast.success("Report generated successfully.");
      }
      if (doDownload) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "ESA_Monthly_Summary_Report.pdf";
        link.click();
      }
      return response.data;
    } catch (error) {
      toast.dismiss();
      toast.error("Error generating report.");
    }
  }
}

export default new ReportingService();
